import { t } from "@web-monorepo/i18n/macro";
import { getImageSrc } from "@web-monorepo/static-assets";
import { DescriptionSlide } from "src/pods/conundrums/components/DescriptionSlide";
import { IntroSlide } from "src/pods/conundrums/components/IntroSlide";
import { OptionsSlide } from "src/pods/conundrums/components/OptionsSlide";
import { PairShareSlide } from "src/pods/conundrums/components/PairShareSlide";
import { ShareToStorySlide } from "src/pods/conundrums/components/ShareToStorySlide";
import { Slide } from "src/pods/conundrums/components/types";

const bruce = getImageSrc("toolkit/src/pods/conundrums/assets/spaceStationBruce.png");
const spaceStationIntroImage = getImageSrc("toolkit/src/pods/conundrums/assets/spaceStationIntro.png");
const katie = getImageSrc("toolkit/src/pods/conundrums/assets/spaceStationKatie.png");
const mojo = getImageSrc("toolkit/src/pods/conundrums/assets/spaceStationMojo.jpg");

const getQuestionText = () => t`Who should be the leader of the space station?`;
const questionOptions = {
  mojo: {
    id: "mojo",
    option: () => t`Mojo`,
    description: () => t`Creative`,
    icon: mojo,
  },
  katie: {
    id: "katie",
    option: () => t`Katie`,
    description: () => t`Hard Worker`,
    icon: katie,
  },
  bruce: {
    id: "bruce",
    option: () => t`Bruce`,
    description: () => t`Super Nice`,
    icon: bruce,
  },
};
const slide2Options = [questionOptions.mojo, questionOptions.katie];
const slide3Options = [questionOptions.mojo, questionOptions.katie, questionOptions.bruce];
const getSentenceStarter = () => t`_____ should be in charge because...`;
const activities: Slide[] = [
  IntroSlide(
    () => t`Space Station`,
    () => t`Mojo and friends are creating a space station, but they can't decide:`,
    () => t`Who should be in charge?`,
    spaceStationIntroImage,
  ),
  DescriptionSlide(
    () => t`Mojo and friends are creating a space station, and need to make a decision`,
    spaceStationIntroImage,
  ),
  OptionsSlide(getQuestionText, slide2Options, [questionOptions.bruce], getSentenceStarter),
  OptionsSlide(getQuestionText, slide3Options, undefined, getSentenceStarter),
  PairShareSlide(
    () =>
      t`Did you like discussing with your classmates? Why?\nWas it hard? Why or why not?\nWhat else did you notice?`,
  ),
  ShareToStorySlide(
    () => t`Congrats on completing this Conundrum!`,
    () => t`Now that was an interesting question indeed.`,
    "https://static.classdojo.com/img/spaceStationShare.png",
    () => t`Great discussion!`,
  ),
];

export default activities;
